import { render } from "./LabPaidCredit2Edit.vue?vue&type=template&id=3fa46306"
import script from "./LabPaidCredit2Edit.vue?vue&type=script&lang=js"
export * from "./LabPaidCredit2Edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__